import { useSlots } from 'vue';

// Has anything been passed for the slot.  When checking the default slot, no name is needed
export function hasSlot(slotName?: string):boolean
{
    const slot = slotName ? useSlots()[slotName] : useSlots().default;
    if (undefined === slot)
        return false;

    return slot().filter(o => "Comment" != o.type)?.length > 0;
}